"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.statusUpdate = exports.deleteById = exports.update = exports.detail = exports.insert = exports.list = void 0;
var U = __importStar(require("./utils"));
var MockData = __importStar(require("./mock-data"));
var utils_1 = require("../utils");
exports.list = function (instance, withBackend) { return function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (!withBackend) {
            console.log('USER list');
            return [2, Promise.resolve(MockData.data.map(function (x) { return U.postProcessing(x); }))];
        }
        return [2, utils_1.request('/superadmin/user/list', instance)];
    });
}); }; };
exports.insert = function (instance, withBackend) { return function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var dataForBackend, r;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!withBackend) {
                    console.log('USER insert', data);
                    return [2, Promise.resolve({ id: 'uuid1' })];
                }
                dataForBackend = {
                    firstName: data.firstName,
                    lastName: data.lastName,
                    email: data.email,
                    status: { id: data.status.id },
                    instance: instance,
                    lang: 'en'
                };
                return [4, utils_1.request('/superadmin/user/insert', dataForBackend)];
            case 1:
                r = _a.sent();
                return [2, { id: r.uuid }];
        }
    });
}); }; };
exports.detail = function (instance, withBackend) { return function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var item;
    return __generator(this, function (_a) {
        if (!withBackend) {
            console.log('USER detail', id);
            item = MockData.data.find(function (x) { return x.uuid === id; });
            return [2, Promise.resolve(U.postProcessing(item || MockData.data[0]))];
        }
        return [2, utils_1.request('/superadmin/user/detail', { uuid: id, instance: instance })];
    });
}); }; };
exports.update = function (instance, withBackend) { return function (data) {
    if (!withBackend) {
        console.log('USER update', data);
        return Promise.resolve(true);
    }
    var dataForBackend = {
        uuid: data.uuid,
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email
    };
    return utils_1.request('/superadmin/user/update', dataForBackend);
}; };
exports.deleteById = function (instance, withBackend) { return function (id) {
    if (!withBackend) {
        console.log('USER delete', id);
        return Promise.resolve(true);
    }
    return utils_1.request('/superadmin/user/delete', { uuid: String(id) });
}; };
exports.statusUpdate = function (withBackend) { return function (uuid, optionId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (!withBackend) {
            console.log('statusUpdate', uuid, optionId);
            return [2, Promise.resolve(true)];
        }
        return [2, utils_1.request('/superadmin/user/status/change', {
                uuid: uuid,
                status: { id: optionId }
            })];
    });
}); }; };
